import { gql } from '@apollo/client';
import USER_FRAGMENT from '../fragments/user';

export default gql`
  mutation TransferUserToFunction($input: TransferUserToFunctionInput!) {
    transferUserToFunction(input: $input) {
      ...UserFragment
    }
  }
  ${USER_FRAGMENT}
`;
